export default "__VITE_ASSET__BFBzgS4m__"